import { combineReducers } from 'redux';
import { IWalletTags } from '@kattana-io/common';
import current, { ICurrentState } from './current';
import watchlist, { IWatchlistState } from './watchlist';
import tickers from './tickers';
import grid, { IGridState } from './grid';
import dex_trades, { IDexTradesState } from './dex_trades';
import modal, { IModalReducerState } from './modal';
import layout, { ILayoutState } from './layout';
import chart_picker, { IChartPicker } from './chart_picker';
import rates, { IRatesReducer } from './rates';
import transactions, { IIntermediateTransaction } from './transactions';
import modal_search, { IModalSearch } from './modal_search';
import notifs, { INotif } from './notifications';
import price_alerts, { IPriceAlertsState } from './price_alerts';
import limit_orders, { ILimitOrdersState } from './limit_orders';
import auth, { IAuthState } from './auth';
import network, { INetworkState } from './network';
import timezone, { ITimezoneState } from './timezone';
import cex_trading, { ICEXTradingState } from './cex_trading';
import cex_orders, { ICEXOrdersState } from './cex_orders';
import registry, { IRegistryReducer } from './registry';
import competition, { ICompetitionState } from './competition';
import wallet_watchlist, { IWalletWatchlistState } from './wallet_watchlist';
import features, { IFeaturesState } from './features';
import walletTags from './wallet_tags';

export interface IStore {
  current: ICurrentState;
  registry: IRegistryReducer;
  watchlist: IWatchlistState;
  tickers: any;
  dex_trades: IDexTradesState;
  transactions: IIntermediateTransaction[];
  modal: IModalReducerState;
  layout: ILayoutState;
  chart_picker: IChartPicker;
  rates: IRatesReducer;
  modal_search: IModalSearch;
  notifs: INotif[];
  grid: IGridState;
  price_alerts: IPriceAlertsState;
  limit_orders: ILimitOrdersState;
  auth: IAuthState;
  network: INetworkState;
  timezone: ITimezoneState;
  cex_trading: ICEXTradingState;
  cex_orders: ICEXOrdersState;
  competition: ICompetitionState;
  wallet_watchlist: IWalletWatchlistState;
  features: IFeaturesState;
  walletTags: IWalletTags;
}

export default combineReducers({
  current,
  registry,
  watchlist,
  tickers,
  dex_trades,
  transactions,
  modal,
  layout,
  chart_picker,
  rates,
  modal_search,
  notifs,
  grid,
  price_alerts,
  limit_orders,
  auth,
  network,
  timezone,
  cex_trading,
  cex_orders,
  competition,
  wallet_watchlist,
  features,
  walletTags,
});
